import type { CptPairEdit } from './cpt';

/** CMS Practitioner PTP v323r0, effective 2026-10-01; active pairs for the supported procedures.
 * Source collection: https://www.cms.gov/medicare/coding-billing/national-correct-coding-initiative-ncci-edits/medicare-ncci-procedure-procedure-ptp-edits
 * Burn example file: https://www.cms.gov/files/zip/medicare-ncci-2026q4-practitioner-ptp-edits-ccipra-v323r0-f1.zip
 * Original column legend: "Modifier 0=not allowed", "1=allowed", "9=not applicable".
 * code = Column 1; bundled = exact Column 2 identities sharing the same modifier indicator.
 * true means a documented modifier exception may apply, not automatic permission to bill both.
 * Scope: supported procedure codes and named urgent-care adjuncts; not the complete CMS file.
 * Example original row: 16025 / 16020 / 19960101 / * / 0 / Mutually exclusive procedures.
 * These are billing reference data, never clinical selection rules. checkCodePairs emits advisory findings only.
 */
export const BURN_TREATMENT_PTP_EDITS: readonly CptPairEdit[] = [
  {
    code: '16000',
    modifierAllowed: true,
    bundled: [
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '16025',
      '16030',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '64450',
      '64454',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '97597',
      '97598',
      '97602',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
    ],
  },
  {
    code: '16020',
    modifierAllowed: true,
    bundled: [
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '16000',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '64450',
      '64454',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '97597',
      '97598',
      '97602',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
    ],
  },
  {
    code: '16025',
    modifierAllowed: true,
    bundled: [
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '64450',
      '64454',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '97597',
      '97598',
      '97602',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
    ],
  },
  {
    code: '16025',
    modifierAllowed: false,
    bundled: ['16020', '36591', '36592', '64451', '96523', '99155', '99156', '99157'],
  },
  {
    code: '16030',
    modifierAllowed: true,
    bundled: [
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '64450',
      '64454',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '97597',
      '97598',
      '97602',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
    ],
  },
  {
    code: '16030',
    modifierAllowed: false,
    bundled: ['16020', '16025', '36591', '36592', '64451', '96523', '99155', '99156', '99157'],
  },
  {
    code: '16000',
    modifierAllowed: false,
    bundled: ['36591', '36592', '64451', '96523', '99155', '99156', '99157'],
  },
  {
    code: '16020',
    modifierAllowed: false,
    bundled: ['36591', '36592', '64451', '96523', '99155', '99156', '99157'],
  },
];

export const CERUMEN_PTP_EDITS: readonly CptPairEdit[] = [
  {
    code: '69209',
    modifierAllowed: true,
    bundled: [
      '11042',
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '97597',
      '97598',
      '97602',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
    ],
  },
  {
    code: '69210',
    modifierAllowed: true,
    bundled: [
      '11042',
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '69209',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '97597',
      '97598',
      '97602',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
    ],
  },
  {
    code: '69209',
    modifierAllowed: false,
    bundled: ['36591', '36592', '64450', '64451', '64454', '96523', '99155', '99156', '99157'],
  },
  {
    code: '69210',
    modifierAllowed: false,
    bundled: ['36591', '36592', '64450', '64451', '64454', '96523', '99155', '99156', '99157'],
  },
];

export const EKG_PTP_EDITS: readonly CptPairEdit[] = [
  {
    code: '93000',
    modifierAllowed: true,
    bundled: ['93005', '93010', '93040', '93041', '93042', '99211'],
  },
  {
    code: '93005',
    modifierAllowed: true,
    bundled: ['93040', '93041', '93042', '99211'],
  },
  {
    code: '93010',
    modifierAllowed: true,
    bundled: ['93040', '93041', '93042', '99211'],
  },
  {
    code: '93000',
    modifierAllowed: false,
    bundled: ['36591', '36592', '96523'],
  },
  {
    code: '93005',
    modifierAllowed: false,
    bundled: ['36591', '36592', '96523'],
  },
  {
    code: '93010',
    modifierAllowed: false,
    bundled: ['36591', '36592', '96523'],
  },
];

export const FOREIGN_BODY_PTP_EDITS: readonly CptPairEdit[] = [
  {
    code: '10120',
    modifierAllowed: true,
    bundled: [
      '11042',
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '64450',
      '64454',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '97597',
      '97598',
      '97602',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
    ],
  },
  {
    code: '10121',
    modifierAllowed: true,
    bundled: [
      '10120',
      '11042',
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '64450',
      '64454',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '97597',
      '97598',
      '97602',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
    ],
  },
  {
    code: '65205',
    modifierAllowed: true,
    bundled: [
      '11042',
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '97597',
      '97598',
      '97602',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
    ],
  },
  {
    code: '65210',
    modifierAllowed: true,
    bundled: [
      '11042',
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '65205',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '97597',
      '97598',
      '97602',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
    ],
  },
  {
    code: '65220',
    modifierAllowed: true,
    bundled: [
      '11042',
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '65430',
      '65435',
      '65436',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '97597',
      '97598',
      '97602',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
    ],
  },
  {
    code: '65222',
    modifierAllowed: true,
    bundled: [
      '11042',
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '65220',
      '65435',
      '65436',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '97597',
      '97598',
      '97602',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
    ],
  },
  {
    code: '69200',
    modifierAllowed: true,
    bundled: [
      '11042',
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '69209',
      '69210',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '97597',
      '97598',
      '97602',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
    ],
  },
  {
    code: '69205',
    modifierAllowed: true,
    bundled: [
      '11042',
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '69200',
      '69209',
      '69210',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '97597',
      '97598',
      '97602',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
    ],
  },
  {
    code: '30300',
    modifierAllowed: true,
    bundled: [
      '11042',
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '30000',
      '30020',
      '30117',
      '30118',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '97597',
      '97598',
      '97602',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
    ],
  },
  {
    code: '10120',
    modifierAllowed: false,
    bundled: ['36591', '36592', '64451', '96523', '99155', '99156', '99157'],
  },
  {
    code: '10121',
    modifierAllowed: false,
    bundled: ['36591', '36592', '64451', '96523', '99155', '99156', '99157'],
  },
  {
    code: '30300',
    modifierAllowed: false,
    bundled: ['36591', '36592', '64450', '64451', '64454', '96523', '99155', '99156', '99157'],
  },
  {
    code: '65205',
    modifierAllowed: false,
    bundled: ['36591', '36592', '64450', '64451', '64454', '96523', '99155', '99156', '99157'],
  },
  {
    code: '65210',
    modifierAllowed: false,
    bundled: ['36591', '36592', '64450', '64451', '64454', '96523', '99155', '99156', '99157'],
  },
  {
    code: '65220',
    modifierAllowed: false,
    bundled: ['36591', '36592', '64450', '64451', '64454', '96523', '99155', '99156', '99157'],
  },
  {
    code: '65222',
    modifierAllowed: false,
    bundled: ['36591', '36592', '64450', '64451', '64454', '96523', '99155', '99156', '99157'],
  },
  {
    code: '69200',
    modifierAllowed: false,
    bundled: ['36591', '36592', '64450', '64451', '64454', '96523', '99155', '99156', '99157'],
  },
  {
    code: '69205',
    modifierAllowed: false,
    bundled: [
      '36591',
      '36592',
      '64450',
      '64451',
      '64454',
      '96523',
      '99151',
      '99152',
      '99153',
      '99155',
      '99156',
      '99157',
    ],
  },
];

export const INCISION_DRAINAGE_PTP_EDITS: readonly CptPairEdit[] = [
  {
    code: '10060',
    modifierAllowed: true,
    bundled: [
      '11740',
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '29580',
      '30000',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '64450',
      '64454',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '97597',
      '97598',
      '97602',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
    ],
  },
  {
    code: '10061',
    modifierAllowed: true,
    bundled: [
      '10060',
      '11740',
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '29580',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '64450',
      '64454',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '97597',
      '97598',
      '97602',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
    ],
  },
  {
    code: '10140',
    modifierAllowed: true,
    bundled: [
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '29580',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '64450',
      '64454',
      '76942',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
    ],
  },
  {
    code: '10160',
    modifierAllowed: true,
    bundled: [
      '10061',
      '10140',
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '29580',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '64450',
      '64454',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
    ],
  },
  {
    code: '10180',
    modifierAllowed: true,
    bundled: [
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '64450',
      '64454',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
    ],
  },
  {
    code: '10060',
    modifierAllowed: false,
    bundled: ['36591', '36592', '64451', '96523', '99155', '99156', '99157'],
  },
  {
    code: '10061',
    modifierAllowed: false,
    bundled: ['36591', '36592', '64451', '96523', '99155', '99156', '99157'],
  },
  {
    code: '10140',
    modifierAllowed: false,
    bundled: ['36591', '36592', '64451', '96523', '99155', '99156', '99157'],
  },
  {
    code: '10160',
    modifierAllowed: false,
    bundled: ['36591', '36592', '64451', '96523', '99155', '99156', '99157'],
  },
  {
    code: '10180',
    modifierAllowed: false,
    bundled: ['36591', '36592', '64451', '96523', '99155', '99156', '99157'],
  },
];

export const INJECTION_INFUSION_PTP_EDITS: readonly CptPairEdit[] = [
  {
    code: '96365',
    modifierAllowed: true,
    bundled: [
      '36000',
      '36410',
      '64450',
      '96360',
      '96372',
      '96374',
      '99202',
      '99203',
      '99204',
      '99205',
      '99212',
      '99213',
      '99214',
      '99215',
      '99358',
      '99359',
    ],
  },
  {
    code: '96365',
    modifierAllowed: false,
    bundled: ['36591', '36592', '96523', '99211'],
  },
  {
    code: '96372',
    modifierAllowed: true,
    bundled: ['99202', '99203', '99204', '99205', '99212', '99213', '99214', '99215', '99358', '99359'],
  },
  {
    code: '96372',
    modifierAllowed: false,
    bundled: ['36591', '36592', '96523', '99211'],
  },
  {
    code: '96374',
    modifierAllowed: true,
    bundled: [
      '36000',
      '96372',
      '99202',
      '99203',
      '99204',
      '99205',
      '99212',
      '99213',
      '99214',
      '99215',
      '99358',
      '99359',
    ],
  },
  {
    code: '96374',
    modifierAllowed: false,
    bundled: ['36591', '36592', '96523', '99211'],
  },
  {
    code: '96366',
    modifierAllowed: false,
    bundled: ['36591', '36592', '96523'],
  },
  {
    code: '96366',
    modifierAllowed: true,
    bundled: ['99358', '99359'],
  },
];

export const IV_CATHETER_PLACEMENT_PTP_EDITS: readonly CptPairEdit[] = [
  {
    code: '36000',
    modifierAllowed: false,
    bundled: ['36591', '36592', '96523'],
  },
];

export const LACERATION_PTP_EDITS: readonly CptPairEdit[] = [
  {
    code: '12001',
    modifierAllowed: true,
    bundled: [
      '11042',
      '11740',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '64450',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '97597',
      '97598',
      '97602',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
      'G0168',
    ],
  },
  {
    code: '12002',
    modifierAllowed: true,
    bundled: [
      '11042',
      '11740',
      '12013',
      '12014',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '64450',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '97597',
      '97598',
      '97602',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
      'G0168',
    ],
  },
  {
    code: '12002',
    modifierAllowed: false,
    bundled: ['12001', '36591', '36592', '96523', '99155', '99156', '99157'],
  },
  {
    code: '12004',
    modifierAllowed: true,
    bundled: [
      '11042',
      '12015',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '64450',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '97597',
      '97598',
      '97602',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
      'G0168',
    ],
  },
  {
    code: '12004',
    modifierAllowed: false,
    bundled: ['12001', '12002', '36591', '36592', '96523', '99155', '99156', '99157'],
  },
  {
    code: '12005',
    modifierAllowed: true,
    bundled: [
      '11042',
      '12016',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '64450',
      '64451',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '97597',
      '97598',
      '97602',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
      'G0168',
    ],
  },
  {
    code: '12005',
    modifierAllowed: false,
    bundled: ['12001', '12002', '12004', '36591', '36592', '96523', '99155', '99156', '99157'],
  },
  {
    code: '12006',
    modifierAllowed: true,
    bundled: [
      '11042',
      '12017',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '64450',
      '64451',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '97597',
      '97598',
      '97602',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
      'G0168',
    ],
  },
  {
    code: '12006',
    modifierAllowed: false,
    bundled: ['12001', '12002', '12004', '12005', '36591', '36592', '96523', '99155', '99156', '99157'],
  },
  {
    code: '12007',
    modifierAllowed: false,
    bundled: ['12001', '12002', '12004', '12005', '12006', '36591', '36592', '96523', '99155', '99156', '99157'],
  },
  {
    code: '12007',
    modifierAllowed: true,
    bundled: [
      '12018',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '64450',
      '64451',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '97597',
      '97598',
      '97602',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
      'G0168',
    ],
  },
  {
    code: '12011',
    modifierAllowed: true,
    bundled: [
      '11042',
      '12001',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '64450',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '97597',
      '97598',
      '97602',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
      'G0168',
    ],
  },
  {
    code: '12013',
    modifierAllowed: true,
    bundled: [
      '11042',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '64450',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '97597',
      '97598',
      '97602',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
      'G0168',
    ],
  },
  {
    code: '12013',
    modifierAllowed: false,
    bundled: ['12011', '36591', '36592', '96523', '99155', '99156', '99157'],
  },
  {
    code: '12014',
    modifierAllowed: false,
    bundled: ['12011', '12013', '36591', '36592', '96523', '99155', '99156', '99157'],
  },
  {
    code: '12014',
    modifierAllowed: true,
    bundled: [
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '64450',
      '64451',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '97597',
      '97598',
      '97602',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
      'G0168',
    ],
  },
  {
    code: '12015',
    modifierAllowed: true,
    bundled: [
      '11042',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '64450',
      '64451',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '97597',
      '97598',
      '97602',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
      'G0168',
    ],
  },
  {
    code: '12015',
    modifierAllowed: false,
    bundled: ['12011', '12013', '12014', '36591', '36592', '96523', '99155', '99156', '99157'],
  },
  {
    code: '12016',
    modifierAllowed: false,
    bundled: ['12011', '12013', '12014', '12015', '36591', '36592', '96523', '99155', '99156', '99157'],
  },
  {
    code: '12016',
    modifierAllowed: true,
    bundled: [
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '64450',
      '64451',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '97597',
      '97598',
      '97602',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
      'G0168',
    ],
  },
  {
    code: '12017',
    modifierAllowed: false,
    bundled: ['12011', '12013', '12014', '12015', '12016', '36591', '36592', '96523', '99155', '99156', '99157'],
  },
  {
    code: '12017',
    modifierAllowed: true,
    bundled: [
      '11010',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '64450',
      '64451',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '97597',
      '97598',
      '97602',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
      'G0168',
    ],
  },
  {
    code: '12018',
    modifierAllowed: false,
    bundled: [
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '36591',
      '36592',
      '96523',
      '99155',
      '99156',
      '99157',
    ],
  },
  {
    code: '12018',
    modifierAllowed: true,
    bundled: [
      '11010',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '64450',
      '64451',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '97597',
      '97598',
      '97602',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
      'G0168',
    ],
  },
  {
    code: '12031',
    modifierAllowed: true,
    bundled: [
      '11042',
      '12051',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '64450',
      '64451',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '97597',
      '97598',
      '97602',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
      'G0168',
    ],
  },
  {
    code: '12032',
    modifierAllowed: true,
    bundled: [
      '11042',
      '12042',
      '12052',
      '12053',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '64450',
      '64451',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '97597',
      '97598',
      '97602',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
      'G0168',
    ],
  },
  {
    code: '12032',
    modifierAllowed: false,
    bundled: ['12031', '36591', '36592', '96523', '99155', '99156', '99157'],
  },
  {
    code: '12034',
    modifierAllowed: true,
    bundled: [
      '11042',
      '12044',
      '12054',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '64450',
      '64451',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '97597',
      '97598',
      '97602',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
      'G0168',
    ],
  },
  {
    code: '12034',
    modifierAllowed: false,
    bundled: ['12031', '12032', '36591', '36592', '96523', '99155', '99156', '99157'],
  },
  {
    code: '12035',
    modifierAllowed: true,
    bundled: [
      '11042',
      '12045',
      '12055',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '64450',
      '64451',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '97597',
      '97598',
      '97602',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
      'G0168',
    ],
  },
  {
    code: '12035',
    modifierAllowed: false,
    bundled: ['12031', '12032', '12034', '36591', '36592', '96523', '99155', '99156', '99157'],
  },
  {
    code: '12036',
    modifierAllowed: false,
    bundled: ['12031', '12032', '12034', '12035', '36591', '36592', '96523', '99155', '99156', '99157'],
  },
  {
    code: '12036',
    modifierAllowed: true,
    bundled: [
      '12046',
      '12056',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '64450',
      '64451',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '97597',
      '97598',
      '97602',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
      'G0168',
    ],
  },
  {
    code: '12037',
    modifierAllowed: false,
    bundled: ['12031', '12032', '12034', '12035', '12036', '36591', '36592', '96523', '99155', '99156', '99157'],
  },
  {
    code: '12037',
    modifierAllowed: true,
    bundled: [
      '12057',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '64450',
      '64451',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '97597',
      '97598',
      '97602',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
      'G0168',
    ],
  },
  {
    code: '12041',
    modifierAllowed: true,
    bundled: [
      '11740',
      '12031',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '64450',
      '64451',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '97597',
      '97598',
      '97602',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
      'G0168',
    ],
  },
  {
    code: '12042',
    modifierAllowed: true,
    bundled: [
      '11042',
      '11740',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '64450',
      '64451',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '97597',
      '97598',
      '97602',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
      'G0168',
    ],
  },
  {
    code: '12042',
    modifierAllowed: false,
    bundled: ['12041', '36591', '36592', '96523', '99155', '99156', '99157'],
  },
  {
    code: '12044',
    modifierAllowed: false,
    bundled: ['12041', '12042', '36591', '36592', '96523', '99155', '99156', '99157'],
  },
  {
    code: '12044',
    modifierAllowed: true,
    bundled: [
      '12054',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '64450',
      '64451',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '97597',
      '97598',
      '97602',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
      'G0168',
    ],
  },
  {
    code: '12045',
    modifierAllowed: true,
    bundled: [
      '11042',
      '12055',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '64450',
      '64451',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '97597',
      '97598',
      '97602',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
      'G0168',
    ],
  },
  {
    code: '12045',
    modifierAllowed: false,
    bundled: ['12041', '12042', '12044', '36591', '36592', '96523', '99155', '99156', '99157'],
  },
  {
    code: '12046',
    modifierAllowed: false,
    bundled: ['12041', '12042', '12044', '12045', '36591', '36592', '96523', '99155', '99156', '99157'],
  },
  {
    code: '12046',
    modifierAllowed: true,
    bundled: [
      '12056',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '64450',
      '64451',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '97597',
      '97598',
      '97602',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
      'G0168',
    ],
  },
  {
    code: '12047',
    modifierAllowed: true,
    bundled: [
      '12037',
      '12057',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '64450',
      '64451',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '97597',
      '97598',
      '97602',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
      'G0168',
    ],
  },
  {
    code: '12047',
    modifierAllowed: false,
    bundled: ['12041', '12042', '12044', '12045', '12046', '36591', '36592', '96523', '99155', '99156', '99157'],
  },
  {
    code: '12051',
    modifierAllowed: true,
    bundled: [
      '11042',
      '12041',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '64450',
      '64451',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '97597',
      '97598',
      '97602',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
      'G0168',
    ],
  },
  {
    code: '12052',
    modifierAllowed: true,
    bundled: [
      '11042',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '64450',
      '64451',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '97597',
      '97598',
      '97602',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
      'G0168',
    ],
  },
  {
    code: '12052',
    modifierAllowed: false,
    bundled: ['12051', '36591', '36592', '96523', '99155', '99156', '99157'],
  },
  {
    code: '12053',
    modifierAllowed: false,
    bundled: ['12051', '12052', '36591', '36592', '96523', '99155', '99156', '99157'],
  },
  {
    code: '12053',
    modifierAllowed: true,
    bundled: [
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '64450',
      '64451',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '97597',
      '97598',
      '97602',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
      'G0168',
    ],
  },
  {
    code: '12054',
    modifierAllowed: true,
    bundled: [
      '11042',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '64450',
      '64451',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '97597',
      '97598',
      '97602',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
      'G0168',
    ],
  },
  {
    code: '12054',
    modifierAllowed: false,
    bundled: ['12051', '12052', '12053', '36591', '36592', '96523', '99155', '99156', '99157'],
  },
  {
    code: '12055',
    modifierAllowed: false,
    bundled: ['12051', '12052', '12053', '12054', '36591', '36592', '96523', '99155', '99156', '99157'],
  },
  {
    code: '12055',
    modifierAllowed: true,
    bundled: [
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '64450',
      '64451',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '97597',
      '97598',
      '97602',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
      'G0168',
    ],
  },
  {
    code: '12056',
    modifierAllowed: false,
    bundled: ['12051', '12052', '12053', '12054', '12055', '36591', '36592', '96523', '99155', '99156', '99157'],
  },
  {
    code: '12056',
    modifierAllowed: true,
    bundled: [
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '64450',
      '64451',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '97597',
      '97598',
      '97602',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
      'G0168',
    ],
  },
  {
    code: '12057',
    modifierAllowed: false,
    bundled: [
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '36591',
      '36592',
      '96523',
      '99155',
      '99156',
      '99157',
    ],
  },
  {
    code: '12057',
    modifierAllowed: true,
    bundled: [
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '64450',
      '64451',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '97597',
      '97598',
      '97602',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
      'G0168',
    ],
  },
  {
    code: '13100',
    modifierAllowed: true,
    bundled: [
      '11010',
      '11011',
      '11012',
      '11042',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '64450',
      '64451',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '97597',
      '97598',
      '97602',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
      'G0168',
    ],
  },
  {
    code: '13100',
    modifierAllowed: false,
    bundled: ['13102', '36591', '36592', '96523', '99155', '99156', '99157'],
  },
  {
    code: '13101',
    modifierAllowed: true,
    bundled: [
      '11010',
      '11011',
      '11012',
      '11042',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '64450',
      '64451',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '97597',
      '97598',
      '97602',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
      'G0168',
    ],
  },
  {
    code: '13101',
    modifierAllowed: false,
    bundled: ['13100', '36591', '36592', '96523', '99155', '99156', '99157'],
  },
  {
    code: '13120',
    modifierAllowed: true,
    bundled: [
      '11010',
      '11011',
      '11012',
      '11042',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '64450',
      '64451',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '97597',
      '97598',
      '97602',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
      'G0168',
    ],
  },
  {
    code: '13120',
    modifierAllowed: false,
    bundled: ['13122', '36591', '36592', '96523', '99155', '99156', '99157'],
  },
  {
    code: '13121',
    modifierAllowed: true,
    bundled: [
      '11010',
      '11011',
      '11012',
      '11042',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '64450',
      '64451',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '97597',
      '97598',
      '97602',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
      'G0168',
    ],
  },
  {
    code: '13121',
    modifierAllowed: false,
    bundled: ['13120', '36591', '36592', '96523', '99155', '99156', '99157'],
  },
  {
    code: '13131',
    modifierAllowed: true,
    bundled: [
      '11010',
      '11011',
      '11012',
      '11042',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '64450',
      '64451',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '97597',
      '97598',
      '97602',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
      'G0168',
    ],
  },
  {
    code: '13131',
    modifierAllowed: false,
    bundled: ['13133', '36591', '36592', '96523', '99155', '99156', '99157'],
  },
  {
    code: '13132',
    modifierAllowed: true,
    bundled: [
      '11010',
      '11011',
      '11012',
      '11042',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '64450',
      '64451',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '97597',
      '97598',
      '97602',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
      'G0168',
    ],
  },
  {
    code: '13132',
    modifierAllowed: false,
    bundled: ['13131', '36591', '36592', '96523', '99155', '99156', '99157'],
  },
  {
    code: '13151',
    modifierAllowed: true,
    bundled: [
      '11010',
      '11011',
      '11012',
      '11042',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '64450',
      '64451',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '97597',
      '97598',
      '97602',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
      'G0168',
    ],
  },
  {
    code: '13151',
    modifierAllowed: false,
    bundled: ['13153', '36591', '36592', '96523', '99155', '99156', '99157'],
  },
  {
    code: '13152',
    modifierAllowed: true,
    bundled: [
      '11010',
      '11011',
      '11012',
      '11042',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '64450',
      '64451',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '97597',
      '97598',
      '97602',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
      'G0168',
    ],
  },
  {
    code: '13152',
    modifierAllowed: false,
    bundled: ['13151', '36591', '36592', '96523', '99155', '99156', '99157'],
  },
  {
    code: 'G0168',
    modifierAllowed: true,
    bundled: [
      '11042',
      '13102',
      '13122',
      '13133',
      '13153',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '97597',
      '97598',
      '97602',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
    ],
  },
  {
    code: '12001',
    modifierAllowed: false,
    bundled: ['36591', '36592', '96523', '99155', '99156', '99157'],
  },
  {
    code: '12011',
    modifierAllowed: false,
    bundled: ['36591', '36592', '96523', '99155', '99156', '99157'],
  },
  {
    code: '12031',
    modifierAllowed: false,
    bundled: ['36591', '36592', '96523', '99155', '99156', '99157'],
  },
  {
    code: '12041',
    modifierAllowed: false,
    bundled: ['36591', '36592', '96523', '99155', '99156', '99157'],
  },
  {
    code: '12051',
    modifierAllowed: false,
    bundled: ['36591', '36592', '96523', '99155', '99156', '99157'],
  },
  {
    code: '13102',
    modifierAllowed: false,
    bundled: ['36591', '36592', '96523'],
  },
  {
    code: '13122',
    modifierAllowed: false,
    bundled: ['36591', '36592', '96523'],
  },
  {
    code: '13133',
    modifierAllowed: false,
    bundled: ['36591', '36592', '96523'],
  },
  {
    code: '13133',
    modifierAllowed: true,
    bundled: ['64451'],
  },
  {
    code: '13153',
    modifierAllowed: false,
    bundled: ['36591', '36592', '96523'],
  },
  {
    code: '13153',
    modifierAllowed: true,
    bundled: ['64451'],
  },
  {
    code: 'G0168',
    modifierAllowed: false,
    bundled: ['36591', '36592', '64450', '64451', '64454', '96523', '99155', '99156', '99157'],
  },
];

export const LESION_DESTRUCTION_PTP_EDITS: readonly CptPairEdit[] = [
  {
    code: '17110',
    modifierAllowed: true,
    bundled: [
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '64450',
      '64454',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '97597',
      '97598',
      '97602',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
    ],
  },
  {
    code: '17111',
    modifierAllowed: true,
    bundled: [
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '64450',
      '64454',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
    ],
  },
  {
    code: '17111',
    modifierAllowed: false,
    bundled: ['17110', '36591', '36592', '64451', '96523', '99155', '99156', '99157'],
  },
  {
    code: '17110',
    modifierAllowed: false,
    bundled: ['36591', '36592', '64451', '96523', '99155', '99156', '99157'],
  },
];

export const NAIL_TREPHINATION_PTP_EDITS: readonly CptPairEdit[] = [
  {
    code: '11740',
    modifierAllowed: true,
    bundled: [
      '10140',
      '10160',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '29125',
      '29126',
      '29130',
      '29131',
      '29515',
      '29540',
      '29580',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '64450',
      '64454',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '96405',
      '96406',
      '97597',
      '97598',
      '97602',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
      'G0168',
    ],
  },
  {
    code: '11740',
    modifierAllowed: false,
    bundled: ['36591', '36592', '64451', '96523', '99155', '99156', '99157'],
  },
];

export const NASAL_PACKING_PTP_EDITS: readonly CptPairEdit[] = [
  {
    code: '30901',
    modifierAllowed: true,
    bundled: [
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '30906',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
    ],
  },
  {
    code: '30903',
    modifierAllowed: true,
    bundled: [
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '30901',
      '30906',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
    ],
  },
  {
    code: '30905',
    modifierAllowed: true,
    bundled: [
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '30901',
      '30903',
      '30906',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
    ],
  },
  {
    code: '30906',
    modifierAllowed: true,
    bundled: [
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
    ],
  },
  {
    code: '30901',
    modifierAllowed: false,
    bundled: ['36591', '36592', '64450', '64451', '64454', '96523', '99155', '99156', '99157'],
  },
  {
    code: '30903',
    modifierAllowed: false,
    bundled: ['36591', '36592', '64450', '64451', '64454', '96523', '99155', '99156', '99157'],
  },
  {
    code: '30905',
    modifierAllowed: false,
    bundled: ['36591', '36592', '64450', '64451', '64454', '96523', '99155', '99156', '99157'],
  },
  {
    code: '30906',
    modifierAllowed: false,
    bundled: ['36591', '36592', '64450', '64451', '64454', '96523', '99155', '99156', '99157'],
  },
];

export const NEBULIZER_PTP_EDITS: readonly CptPairEdit[] = [
  {
    code: '94640',
    modifierAllowed: true,
    bundled: ['99202', '99203', '99204', '99205', '99211', '99212', '99213', '99214', '99215'],
  },
  {
    code: '94640',
    modifierAllowed: false,
    bundled: ['36591', '36592', '96523'],
  },
];

export const NURSEMAID_ELBOW_PTP_EDITS: readonly CptPairEdit[] = [
  {
    code: '24640',
    modifierAllowed: true,
    bundled: [
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '29105',
      '29240',
      '29260',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '64450',
      '64454',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '97597',
      '97598',
      '97602',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
    ],
  },
  {
    code: '24640',
    modifierAllowed: false,
    bundled: ['36591', '36592', '64451', '96523', '99155', '99156', '99157'],
  },
];

export const SPLINTING_PTP_EDITS: readonly CptPairEdit[] = [
  {
    code: '29105',
    modifierAllowed: true,
    bundled: [
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12013',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '29125',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '64450',
      '64454',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
      'G0168',
    ],
  },
  {
    code: '29125',
    modifierAllowed: true,
    bundled: [
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '29130',
      '29260',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '64450',
      '64454',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
      'G0168',
    ],
  },
  {
    code: '29126',
    modifierAllowed: true,
    bundled: [
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '64450',
      '64454',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
    ],
  },
  {
    code: '29130',
    modifierAllowed: true,
    bundled: [
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '64450',
      '64454',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
    ],
  },
  {
    code: '29131',
    modifierAllowed: true,
    bundled: [
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '64450',
      '64454',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
    ],
  },
  {
    code: '29200',
    modifierAllowed: true,
    bundled: [
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '64450',
      '64454',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
    ],
  },
  {
    code: '29240',
    modifierAllowed: true,
    bundled: [
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '64450',
      '64454',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
    ],
  },
  {
    code: '29260',
    modifierAllowed: true,
    bundled: [
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '64450',
      '64454',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
    ],
  },
  {
    code: '29505',
    modifierAllowed: true,
    bundled: [
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '29515',
      '29540',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '64450',
      '64454',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
    ],
  },
  {
    code: '29515',
    modifierAllowed: true,
    bundled: [
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '29540',
      '29580',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
    ],
  },
  {
    code: '29520',
    modifierAllowed: true,
    bundled: [
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '64450',
      '64451',
      '64454',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
    ],
  },
  {
    code: '29530',
    modifierAllowed: true,
    bundled: [
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '64450',
      '64451',
      '64454',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
    ],
  },
  {
    code: '29540',
    modifierAllowed: true,
    bundled: [
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
    ],
  },
  {
    code: '29580',
    modifierAllowed: true,
    bundled: [
      '12001',
      '12005',
      '12006',
      '12007',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '29540',
      '36000',
      '36410',
      '51701',
      '51702',
      '51703',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
    ],
  },
  {
    code: '29105',
    modifierAllowed: false,
    bundled: ['36591', '36592', '64451', '96523', '99155', '99156', '99157'],
  },
  {
    code: '29125',
    modifierAllowed: false,
    bundled: ['36591', '36592', '64451', '96523', '99155', '99156', '99157'],
  },
  {
    code: '29126',
    modifierAllowed: false,
    bundled: ['36591', '36592', '64451', '96523', '99155', '99156', '99157'],
  },
  {
    code: '29130',
    modifierAllowed: false,
    bundled: ['36591', '36592', '96523', '99155', '99156', '99157'],
  },
  {
    code: '29131',
    modifierAllowed: false,
    bundled: ['36591', '36592', '64451', '96523', '99155', '99156', '99157'],
  },
  {
    code: '29200',
    modifierAllowed: false,
    bundled: ['36591', '36592', '64451', '96523', '99155', '99156', '99157'],
  },
  {
    code: '29240',
    modifierAllowed: false,
    bundled: ['36591', '36592', '64451', '96523', '99155', '99156', '99157'],
  },
  {
    code: '29260',
    modifierAllowed: false,
    bundled: ['36591', '36592', '64451', '96523', '99155', '99156', '99157'],
  },
  {
    code: '29505',
    modifierAllowed: false,
    bundled: ['36591', '36592', '64451', '96523', '99155', '99156', '99157'],
  },
  {
    code: '29515',
    modifierAllowed: false,
    bundled: ['36591', '36592', '96523', '99155', '99156', '99157'],
  },
  {
    code: '29520',
    modifierAllowed: false,
    bundled: ['36591', '36592', '96523', '99155', '99156', '99157'],
  },
  {
    code: '29530',
    modifierAllowed: false,
    bundled: ['36591', '36592', '96523', '99155', '99156', '99157'],
  },
  {
    code: '29540',
    modifierAllowed: false,
    bundled: ['36591', '36592', '96523', '99155', '99156', '99157'],
  },
  {
    code: '29580',
    modifierAllowed: false,
    bundled: ['36591', '36592', '96523', '99155', '99156', '99157'],
  },
];

export const URINARY_CATHETERIZATION_PTP_EDITS: readonly CptPairEdit[] = [
  {
    code: '51701',
    modifierAllowed: true,
    bundled: [
      '11042',
      '13102',
      '13122',
      '13133',
      '13153',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '97597',
      '97598',
      '97602',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
    ],
  },
  {
    code: '51701',
    modifierAllowed: false,
    bundled: ['36591', '36592', '96523', '99155', '99156', '99157', 'P9612'],
  },
  {
    code: '51702',
    modifierAllowed: true,
    bundled: [
      '11042',
      '13102',
      '13122',
      '13133',
      '13153',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '97597',
      '97598',
      '97602',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
    ],
  },
  {
    code: '51702',
    modifierAllowed: false,
    bundled: ['36591', '36592', '51701', '96523', '99155', '99156', '99157', 'P9612'],
  },
  {
    code: '51703',
    modifierAllowed: true,
    bundled: [
      '11042',
      '13102',
      '13122',
      '13133',
      '13153',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96360',
      '96365',
      '96366',
      '96372',
      '96374',
      '97597',
      '97598',
      '97602',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
    ],
  },
  {
    code: '51703',
    modifierAllowed: false,
    bundled: ['36591', '36592', '51701', '51702', '64450', '96523', '99155', '99156', '99157', 'P9612'],
  },
];

/** Adjunct services explicitly discussed in the family sources: venous access/port flush,
 * nerve blocks/orthotic management, fracture care, ocular/nasal procedures and drug-administration exclusions.
 * Only active rows involving the covered procedures are included; this remains a bounded CMS subset.
 * https://www.cms.gov/files/document/04-chapter4-ncci-medicare-policy-manual-2026-final.pdf (§C, G)
 * https://www.cms.gov/files/document/08-chapter8-ncci-medicare-policy-manual-2026-final.pdf (§D)
 * https://www.cms.gov/files/document/11-chapter11a-ncci-medicare-policy-manual-2026-final.pdf (§B, I)
 * Values are copied from the four practitioner v323r0 files linked above, not inferred from those narratives.
 */
export const ADJUNCT_PAIR_EDITS: readonly CptPairEdit[] = [
  {
    code: '11042',
    modifierAllowed: true,
    bundled: [
      '10060',
      '12007',
      '12014',
      '12016',
      '12017',
      '12018',
      '12036',
      '12037',
      '12041',
      '12044',
      '12046',
      '12047',
      '12053',
      '12055',
      '12056',
      '12057',
      '13102',
      '13122',
      '13133',
      '13153',
      '29105',
      '29125',
      '29126',
      '29130',
      '29131',
      '29200',
      '29240',
      '29260',
      '29505',
      '29515',
      '29520',
      '29530',
      '29540',
      '29580',
      '36000',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96365',
      '96366',
      '96372',
      '96374',
      '97597',
      '97598',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
    ],
  },
  {
    code: '93040',
    modifierAllowed: true,
    bundled: ['93041', '93042'],
  },
  {
    code: '94060',
    modifierAllowed: true,
    bundled: [
      '36000',
      '94640',
      '96365',
      '96372',
      '96374',
      '99202',
      '99203',
      '99204',
      '99205',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
    ],
  },
  {
    code: '97597',
    modifierAllowed: true,
    bundled: [
      '13102',
      '13122',
      '13133',
      '13153',
      '29105',
      '29125',
      '29126',
      '29130',
      '29131',
      '29200',
      '29240',
      '29260',
      '29505',
      '29515',
      '29520',
      '29530',
      '29540',
      '29580',
      '36000',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96365',
      '96366',
      '96372',
      '96374',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
    ],
  },
  {
    code: '97598',
    modifierAllowed: true,
    bundled: [
      '29105',
      '29125',
      '29126',
      '29130',
      '29131',
      '29200',
      '29240',
      '29260',
      '29505',
      '29515',
      '29520',
      '29530',
      '29540',
      '29580',
      '96372',
      '96374',
    ],
  },
  {
    code: '99202',
    modifierAllowed: true,
    bundled: ['99211', '99212', '99213', '99214', '99215'],
  },
  {
    code: '99203',
    modifierAllowed: false,
    bundled: ['99202'],
  },
  {
    code: '99203',
    modifierAllowed: true,
    bundled: ['99211', '99212', '99213', '99214', '99215'],
  },
  {
    code: '99204',
    modifierAllowed: false,
    bundled: ['99202', '99203'],
  },
  {
    code: '99204',
    modifierAllowed: true,
    bundled: ['99211', '99212', '99213', '99214', '99215'],
  },
  {
    code: '99205',
    modifierAllowed: false,
    bundled: ['99202', '99203', '99204'],
  },
  {
    code: '99205',
    modifierAllowed: true,
    bundled: ['99211', '99212', '99213', '99214', '99215'],
  },
  {
    code: '99212',
    modifierAllowed: true,
    bundled: ['99211'],
  },
  {
    code: '99213',
    modifierAllowed: true,
    bundled: ['99211', '99212'],
  },
  {
    code: '99214',
    modifierAllowed: true,
    bundled: ['99211', '99212', '99213'],
  },
  {
    code: '99215',
    modifierAllowed: true,
    bundled: ['99211', '99212', '99213', '99214'],
  },
  {
    code: '31231',
    modifierAllowed: true,
    bundled: [
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '30901',
      '30903',
      '30905',
      '36000',
      '51701',
      '51702',
      '51703',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96365',
      '96366',
      '96372',
      '96374',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
    ],
  },
  {
    code: '31238',
    modifierAllowed: true,
    bundled: [
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '30901',
      '30903',
      '30905',
      '30906',
      '36000',
      '51701',
      '51702',
      '51703',
      '93000',
      '93005',
      '93010',
      '93040',
      '93041',
      '93042',
      '96365',
      '96366',
      '96372',
      '96374',
      '99211',
      '99212',
      '99213',
      '99214',
      '99215',
    ],
  },
  {
    code: '31238',
    modifierAllowed: false,
    bundled: ['31231'],
  },
  {
    code: '11010',
    modifierAllowed: true,
    bundled: [
      '10060',
      '10120',
      '10121',
      '10160',
      '10180',
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13102',
      '13122',
      '13133',
      '13153',
      '16000',
      '16020',
      '16025',
      '16030',
      '29105',
      '29125',
      '29126',
      '29130',
      '29131',
      '29200',
      '29240',
      '29260',
      '29505',
      '29515',
      '29520',
      '29530',
      '29540',
      '29580',
      '36000',
      '51701',
      '51702',
      '51703',
      '93000',
      '93005',
      '93010',
      '96365',
      '96366',
      '96372',
      '96374',
      'G0168',
    ],
  },
  {
    code: '11011',
    modifierAllowed: true,
    bundled: [
      '10060',
      '10120',
      '10121',
      '10160',
      '10180',
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13102',
      '13122',
      '13133',
      '13153',
      '16000',
      '16020',
      '16025',
      '16030',
      '29105',
      '29125',
      '29126',
      '29130',
      '29131',
      '29200',
      '29240',
      '29260',
      '29505',
      '29515',
      '29520',
      '29530',
      '29540',
      '29580',
      '36000',
      '51701',
      '51702',
      '51703',
      '93000',
      '93005',
      '93010',
      '96365',
      '96366',
      '96372',
      '96374',
      'G0168',
    ],
  },
  {
    code: '11012',
    modifierAllowed: true,
    bundled: [
      '10060',
      '10120',
      '10121',
      '10160',
      '10180',
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13102',
      '13122',
      '13133',
      '13153',
      '16000',
      '16020',
      '16025',
      '16030',
      '29105',
      '29125',
      '29126',
      '29130',
      '29131',
      '29200',
      '29240',
      '29260',
      '29505',
      '29515',
      '29520',
      '29530',
      '29540',
      '29580',
      '36000',
      '51701',
      '51702',
      '51703',
      '93000',
      '93005',
      '93010',
      '96365',
      '96366',
      '96372',
      '96374',
      'G0168',
    ],
  },
  {
    code: '23333',
    modifierAllowed: true,
    bundled: [
      '10120',
      '10121',
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '36000',
      '51701',
      '51702',
      '51703',
      '93000',
      '93005',
      '93010',
      '96365',
      '96366',
      '96372',
      '96374',
    ],
  },
  {
    code: '23334',
    modifierAllowed: true,
    bundled: [
      '10120',
      '10121',
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '36000',
      '51701',
      '51702',
      '51703',
      '93000',
      '93005',
      '93010',
      '96365',
      '96366',
      '96372',
      '96374',
    ],
  },
  {
    code: '23335',
    modifierAllowed: true,
    bundled: [
      '10120',
      '10121',
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '36000',
      '51701',
      '51702',
      '51703',
      '93000',
      '93005',
      '93010',
      '96365',
      '96366',
      '96372',
      '96374',
    ],
  },
  {
    code: '24650',
    modifierAllowed: true,
    bundled: [
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '29105',
      '29125',
      '29240',
      '29260',
      '36000',
      '51701',
      '51702',
      '51703',
      '93000',
      '93005',
      '93010',
      '96365',
      '96366',
      '96372',
      '96374',
    ],
  },
  {
    code: '25600',
    modifierAllowed: true,
    bundled: [
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '29105',
      '29125',
      '29126',
      '29130',
      '29260',
      '36000',
      '51701',
      '51702',
      '51703',
      '93000',
      '93005',
      '93010',
      '96365',
      '96366',
      '96372',
      '96374',
      'G0168',
    ],
  },
  {
    code: '25605',
    modifierAllowed: true,
    bundled: [
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '29105',
      '29125',
      '29126',
      '29260',
      '36000',
      '51701',
      '51702',
      '51703',
      '93000',
      '93005',
      '93010',
      '96365',
      '96366',
      '96372',
      '96374',
    ],
  },
  {
    code: '26720',
    modifierAllowed: true,
    bundled: [
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '29105',
      '29125',
      '29126',
      '29130',
      '29131',
      '36000',
      '51701',
      '51702',
      '51703',
      '93000',
      '93005',
      '93010',
      '96365',
      '96366',
      '96372',
      '96374',
    ],
  },
  {
    code: '27030',
    modifierAllowed: true,
    bundled: [
      '10060',
      '10061',
      '10120',
      '10121',
      '10140',
      '10160',
      '10180',
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '36000',
      '51701',
      '51702',
      '51703',
      '93000',
      '93005',
      '93010',
      '96365',
      '96366',
      '96372',
      '96374',
    ],
  },
  {
    code: '27086',
    modifierAllowed: true,
    bundled: [
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '36000',
      '51701',
      '51702',
      '51703',
      '93000',
      '93005',
      '93010',
      '96365',
      '96366',
      '96372',
      '96374',
    ],
  },
  {
    code: '27087',
    modifierAllowed: true,
    bundled: [
      '10120',
      '10121',
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '36000',
      '51701',
      '51702',
      '51703',
      '93000',
      '93005',
      '93010',
      '96365',
      '96366',
      '96372',
      '96374',
    ],
  },
  {
    code: '27786',
    modifierAllowed: true,
    bundled: [
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '29505',
      '29515',
      '29540',
      '36000',
      '51701',
      '51702',
      '51703',
      '93000',
      '93005',
      '93010',
      '96365',
      '96366',
      '96372',
      '96374',
    ],
  },
  {
    code: '28190',
    modifierAllowed: true,
    bundled: [
      '10060',
      '10120',
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '29540',
      '36000',
      '51701',
      '51702',
      '51703',
      '93000',
      '93005',
      '93010',
      '96365',
      '96366',
      '96372',
      '96374',
    ],
  },
  {
    code: '28192',
    modifierAllowed: true,
    bundled: [
      '10060',
      '10120',
      '10121',
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '29515',
      '29540',
      '36000',
      '51701',
      '51702',
      '51703',
      '93000',
      '93005',
      '93010',
      '96365',
      '96366',
      '96372',
      '96374',
    ],
  },
  {
    code: '28193',
    modifierAllowed: true,
    bundled: [
      '10060',
      '10120',
      '10121',
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '29540',
      '36000',
      '51701',
      '51702',
      '51703',
      '93000',
      '93005',
      '93010',
      '96365',
      '96366',
      '96372',
      '96374',
    ],
  },
  {
    code: '30000',
    modifierAllowed: true,
    bundled: [
      '10140',
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '36000',
      '51701',
      '51702',
      '51703',
      '93000',
      '93005',
      '93010',
      '96365',
      '96366',
      '96372',
      '96374',
    ],
  },
  {
    code: '30020',
    modifierAllowed: true,
    bundled: [
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '36000',
      '51701',
      '51702',
      '51703',
      '93000',
      '93005',
      '93010',
      '96365',
      '96366',
      '96372',
      '96374',
    ],
  },
  {
    code: '30117',
    modifierAllowed: true,
    bundled: [
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '36000',
      '51701',
      '51702',
      '51703',
      '93000',
      '93005',
      '93010',
      '96365',
      '96366',
      '96372',
      '96374',
    ],
  },
  {
    code: '30118',
    modifierAllowed: true,
    bundled: [
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '36000',
      '51701',
      '51702',
      '51703',
      '93000',
      '93005',
      '93010',
      '96365',
      '96366',
      '96372',
      '96374',
    ],
  },
  {
    code: '30310',
    modifierAllowed: true,
    bundled: [
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '30300',
      '36000',
      '51701',
      '51702',
      '51703',
      '93000',
      '93005',
      '93010',
      '96365',
      '96366',
      '96372',
      '96374',
    ],
  },
  {
    code: '30320',
    modifierAllowed: true,
    bundled: [
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '30300',
      '36000',
      '51701',
      '51702',
      '51703',
      '93000',
      '93005',
      '93010',
      '96365',
      '96366',
      '96372',
      '96374',
    ],
  },
  {
    code: '30915',
    modifierAllowed: true,
    bundled: [
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '30901',
      '30903',
      '30905',
      '30906',
      '36000',
      '51701',
      '51702',
      '51703',
      '93000',
      '93005',
      '93010',
      '96365',
      '96366',
      '96372',
      '96374',
    ],
  },
  {
    code: '30920',
    modifierAllowed: true,
    bundled: [
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '30901',
      '30903',
      '30905',
      '30906',
      '36000',
      '51701',
      '51702',
      '51703',
      '93000',
      '93005',
      '93010',
      '96365',
      '96366',
      '96372',
      '96374',
    ],
  },
  {
    code: '41805',
    modifierAllowed: true,
    bundled: [
      '10120',
      '10121',
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '36000',
      '51701',
      '51702',
      '51703',
      '93000',
      '93005',
      '93010',
      '96365',
      '96366',
      '96372',
      '96374',
    ],
  },
  {
    code: '41806',
    modifierAllowed: true,
    bundled: [
      '10120',
      '10121',
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '36000',
      '51701',
      '51702',
      '51703',
      '93000',
      '93005',
      '93010',
      '96365',
      '96366',
      '96372',
      '96374',
    ],
  },
  {
    code: '42975',
    modifierAllowed: true,
    bundled: [
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '30901',
      '30903',
      '30905',
      '36000',
      '51701',
      '51702',
      '51703',
      '93000',
      '93005',
      '93010',
      '96365',
      '96366',
      '96372',
      '96374',
    ],
  },
  {
    code: '64450',
    modifierAllowed: false,
    bundled: ['29515', '29540', '29580', '51701', '51702'],
  },
  {
    code: '64450',
    modifierAllowed: true,
    bundled: ['93000', '93005', '93010', '96366', '96372', '96374'],
  },
  {
    code: '64451',
    modifierAllowed: false,
    bundled: ['29515', '29540', '29580'],
  },
  {
    code: '64451',
    modifierAllowed: true,
    bundled: [
      '12001',
      '12002',
      '12004',
      '12011',
      '12013',
      '13102',
      '13122',
      '36000',
      '51701',
      '51702',
      '51703',
      '93000',
      '93005',
      '93010',
      '96365',
      '96366',
      '96372',
      '96374',
    ],
  },
  {
    code: '64454',
    modifierAllowed: false,
    bundled: ['29515', '29540', '29580'],
  },
  {
    code: '64454',
    modifierAllowed: true,
    bundled: [
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '36000',
      '51701',
      '51702',
      '51703',
      '93000',
      '93005',
      '93010',
      '96365',
      '96366',
      '96372',
      '96374',
    ],
  },
  {
    code: '64455',
    modifierAllowed: false,
    bundled: ['51701', '51702', '51703'],
  },
  {
    code: '64455',
    modifierAllowed: true,
    bundled: ['29515', '29540', '29580', '36000', '93000', '93005', '93010', '96365', '96366', '96372', '96374'],
  },
  {
    code: '65275',
    modifierAllowed: true,
    bundled: [
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '36000',
      '51701',
      '51702',
      '51703',
      '65220',
      '65222',
      '93000',
      '93005',
      '93010',
      '96365',
      '96366',
      '96372',
      '96374',
    ],
  },
  {
    code: '65430',
    modifierAllowed: true,
    bundled: [
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '36000',
      '51701',
      '51702',
      '51703',
      '93000',
      '93005',
      '93010',
      '96365',
      '96366',
      '96372',
      '96374',
    ],
  },
  {
    code: '65435',
    modifierAllowed: true,
    bundled: [
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '36000',
      '51701',
      '51702',
      '51703',
      '93000',
      '93005',
      '93010',
      '96365',
      '96366',
      '96372',
      '96374',
    ],
  },
  {
    code: '65436',
    modifierAllowed: true,
    bundled: [
      '12001',
      '12002',
      '12004',
      '12005',
      '12006',
      '12007',
      '12011',
      '12013',
      '12014',
      '12015',
      '12016',
      '12017',
      '12018',
      '12031',
      '12032',
      '12034',
      '12035',
      '12036',
      '12037',
      '12041',
      '12042',
      '12044',
      '12045',
      '12046',
      '12047',
      '12051',
      '12052',
      '12053',
      '12054',
      '12055',
      '12056',
      '12057',
      '13100',
      '13101',
      '13102',
      '13120',
      '13121',
      '13122',
      '13131',
      '13132',
      '13133',
      '13151',
      '13152',
      '13153',
      '36000',
      '51701',
      '51702',
      '51703',
      '93000',
      '93005',
      '93010',
      '96365',
      '96366',
      '96372',
      '96374',
    ],
  },
  {
    code: '93015',
    modifierAllowed: true,
    bundled: ['36000', '93000', '93005', '93010', '96365', '96372', '96374'],
  },
  {
    code: '93016',
    modifierAllowed: true,
    bundled: ['36000', '93000', '93005', '93010', '96365', '96372', '96374'],
  },
  {
    code: '93017',
    modifierAllowed: true,
    bundled: ['36000', '93000', '93005', '93010', '96365', '96372', '96374'],
  },
  {
    code: '93018',
    modifierAllowed: true,
    bundled: ['36000', '93000', '93005', '93010', '96372', '96374'],
  },
  {
    code: '93024',
    modifierAllowed: true,
    bundled: ['36000', '96365', '96372', '96374'],
  },
  {
    code: '93025',
    modifierAllowed: true,
    bundled: ['93000', '93005', '93010'],
  },
  {
    code: '96360',
    modifierAllowed: true,
    bundled: ['36000', '96372', '96374'],
  },
  {
    code: '96401',
    modifierAllowed: true,
    bundled: ['96372'],
  },
  {
    code: '96402',
    modifierAllowed: true,
    bundled: ['96372'],
  },
  {
    code: '96405',
    modifierAllowed: true,
    bundled: [
      '13102',
      '13122',
      '13133',
      '13153',
      '36000',
      '51701',
      '51702',
      '51703',
      '93000',
      '93005',
      '93010',
      '96365',
      '96366',
      '96372',
      '96374',
    ],
  },
  {
    code: '96406',
    modifierAllowed: true,
    bundled: [
      '13102',
      '13122',
      '13133',
      '13153',
      '36000',
      '51701',
      '51702',
      '51703',
      '93000',
      '93005',
      '93010',
      '96365',
      '96366',
      '96372',
      '96374',
    ],
  },
  {
    code: '96409',
    modifierAllowed: true,
    bundled: ['36000', '96365', '96372', '96374'],
  },
  {
    code: '96413',
    modifierAllowed: true,
    bundled: ['36000', '96365', '96372', '96374'],
  },
  {
    code: '96416',
    modifierAllowed: true,
    bundled: ['36000', '96365', '96372', '96374'],
  },
  {
    code: '96420',
    modifierAllowed: true,
    bundled: ['96372'],
  },
  {
    code: '96422',
    modifierAllowed: true,
    bundled: ['96372'],
  },
  {
    code: '96425',
    modifierAllowed: true,
    bundled: ['96365', '96372', '96374'],
  },
  {
    code: '97602',
    modifierAllowed: true,
    bundled: [
      '29105',
      '29125',
      '29126',
      '29130',
      '29131',
      '29200',
      '29240',
      '29260',
      '29505',
      '29515',
      '29520',
      '29530',
      '29540',
      '29580',
      '96372',
      '96374',
    ],
  },
  {
    code: '97760',
    modifierAllowed: true,
    bundled: [
      '29105',
      '29125',
      '29126',
      '29130',
      '29131',
      '29200',
      '29240',
      '29260',
      '29505',
      '29515',
      '29520',
      '29530',
      '29540',
      '29580',
    ],
  },
  {
    code: '97763',
    modifierAllowed: true,
    bundled: [
      '29105',
      '29125',
      '29126',
      '29130',
      '29131',
      '29200',
      '29240',
      '29260',
      '29505',
      '29515',
      '29520',
      '29530',
      '29540',
      '29580',
    ],
  },
  {
    code: '99151',
    modifierAllowed: true,
    bundled: ['36000', '93000', '93005', '93010', '96365', '96372', '96374'],
  },
  {
    code: '99152',
    modifierAllowed: true,
    bundled: ['36000', '93000', '93005', '93010', '96365', '96372', '96374'],
  },
  {
    code: '99155',
    modifierAllowed: false,
    bundled: ['96365', '96372', '96374'],
  },
  {
    code: '99155',
    modifierAllowed: true,
    bundled: ['36000', '93000', '93005', '93010'],
  },
  {
    code: '99156',
    modifierAllowed: false,
    bundled: ['96365', '96372', '96374'],
  },
  {
    code: '99156',
    modifierAllowed: true,
    bundled: ['36000', '93000', '93005', '93010'],
  },
];
